<template>
    <div class="proi-body">
        <DxDataGrid :data-source="ds" ref="gridRef" key-expr="ID" :show-borders="true" height="100%"
            :row-alternation-enabled="true" :hover-state-enabled="true"
            no-data-text="Nu există pontaj pe proiecte pentru angajatul selectat.">
            <DxRemoteOperations :filtering="true" :paging="true" :sorting="true" />
            <DxScrolling mode="virtual" />
            <DxEditing :allow-updating="true" :allow-deleting="true" :allow-adding="true" mode="popup">
                <DxPopup :show-title="true" title="Pontaj proiect" :width="520" :height="360" />
                <DxFormPopup :col-count="1">
                    <DxItem data-field="ProiectID" />
                    <DxItem data-field="OraInceput" />
                    <DxItem data-field="OraFinal" />
                </DxFormPopup>
            </DxEditing>

            <DxColumn data-field="ProiectID" caption="Proiect" :min-width="200">
                <DxLookup :data-source="dsProiecte" value-expr="ProiectId" display-expr="Name" />
            </DxColumn>
            <DxColumn data-field="OraInceput" caption="Oră început" data-type="datetime" format="dd.MM.yyyy HH:mm"
                :width="160" />
            <DxColumn data-field="OraFinal" caption="Oră sfârșit" data-type="datetime" format="dd.MM.yyyy HH:mm"
                :width="160" />
            <DxColumn caption="Durată (h)" :width="100" alignment="center" :calculate-cell-value="durata"
                :allow-editing="false" />
        </DxDataGrid>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import {
    DxDataGrid, DxColumn, DxScrolling, DxEditing, DxLookup, DxPopup,
    DxForm as DxFormPopup, DxItem, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import ODataStore from 'devextreme/data/odata/store';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';

export default defineComponent({
    components: { DxDataGrid, DxColumn, DxScrolling, DxEditing, DxLookup, DxPopup, DxFormPopup, DxItem, DxRemoteOperations },
    props: {
        empId: { type: String, default: null },
        lunaSel: { type: Number, default: null },
        anSel: { type: Number, default: null },
    },
    data() {
        return {
            gridRef: ref(null),
            ds: {} as any,
            dsProiecte: {} as any,
        };
    },
    watch: {
        empId() { this.build(); },
        lunaSel() { this.build(); },
        anSel() { this.build(); },
    },
    methods: {
        durata(row: any): string {
            if (!row?.OraInceput || !row?.OraFinal) return '';
            const h = (new Date(row.OraFinal).getTime() - new Date(row.OraInceput).getTime()) / 3600000;
            return h > 0 ? h.toFixed(1) : '';
        },
        build() {
            // Legacy: lookup = proiectele active ale angajatului (PER_EmpProjectsActive), value=ProiectID, display=Name
            this.dsProiecte = {
                store: new ODataStore({
                    url: AppSetting.API_Url_ResurseUmaneOdata + 'PER_EmpProjects',
                    key: 'Id', keyType: { Id: 'Guid' }, fieldTypes: { Id: 'Guid', EmpId: 'Guid', ProiectId: 'Guid' },
                    beforeSend: (e: any) => { e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; }
                }),
                filter: this.empId ? ['EmpId', '=', this.empId] : ['EmpId', '=', '00000000-0000-0000-0000-000000000000'],
                paginate: false,
            };
            // Legacy: PER_PontajZilnic e filtrat pe LUNA selectata (Fill(..., LunaStart)) — nu tot istoricul
            const empFilter = this.empId
                ? ['IDPersoana', '=', this.empId]
                : ['IDPersoana', '=', '00000000-0000-0000-0000-000000000000'];
            let filter: any = empFilter;
            if (this.lunaSel && this.anSel) {
                const start = new Date(this.anSel, this.lunaSel - 1, 1);
                const end = new Date(this.anSel, this.lunaSel, 1);
                filter = [empFilter, 'and', ['OraInceput', '>=', start], 'and', ['OraInceput', '<', end]];
            }
            this.ds = new DataSource({
                store: new ODataStore({
                    version: 4,
                    url: AppSetting.API_Url_ResurseUmaneOdata + 'PER_PontajZilnic',
                    key: 'ID',
                    keyType: { ID: 'Guid' },
                    fieldTypes: { ID: 'Guid', ProiectID: 'Guid' },
                    beforeSend: (e: any) => { e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; },
                    onInserting: (values: any) => { values.IDPersoana = this.empId; },
                }),
                filter,
            });
        },
    },
    mounted() { this.build(); },
});
</script>
<style scoped>
.proi-body { height: 100%; }
</style>
